import LoadingIcon from "@common/LoadingIcon";
import { PlusCircleIcon } from "@heroicons/react/24/outline";

type UserProfileImageCardProps = {
  previews: string[];
  imageLoading: boolean;
  fileInput: React.RefObject<HTMLInputElement>;
  handleImageLoaded: () => void;
  handleFileDelete: () => void;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const UserProfileImageCard = ({
  previews,
  imageLoading,
  fileInput,
  handleImageLoaded,
  handleFileDelete,
  handleFileChange,
}: UserProfileImageCardProps) => {
  return (
    <>
      <div>
        {previews.length >= 1 ? (
          <ul className="flex">
            {previews.map((preview, index) => (
              <li key={index} className="flex mt-10 flex-col items-center">
                <div className="flex">
                  <div className="relative">
                    {imageLoading && (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <LoadingIcon />
                      </div>
                    )}
                    <img
                      src={preview}
                      alt={`preview ${index}`}
                      onLoad={handleImageLoaded}
                      className={`w-50 h-50 rounded-full object-contain cursor-pointer hover:opacity-50 ${
                        imageLoading ? "opacity-0" : "opacity-100"
                      }`}
                      onClick={() => fileInput.current.click()}
                    />
                  </div>
                </div>

                <div className="flex items-center gap-2 mt-10 cursor-pointer hover:opacity-50">
                  <svg
                    width="20"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    className="text-mayo-link-text"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14 5V4.2C14 3.0799 14 2.51984 13.782 2.09202C13.5903 1.71569 13.2843 1.40973 12.908 1.21799C12.4802 1 11.9201 1 10.8 1H9.2C8.07989 1 7.51984 1 7.09202 1.21799C6.71569 1.40973 6.40973 1.71569 6.21799 2.09202C6 2.51984 6 3.0799 6 4.2V5M8 10.5V15.5M12 10.5V15.5M1 5H19M17 5V16.2C17 17.8802 17 18.7202 16.673 19.362C16.3854 19.9265 15.9265 20.3854 15.362 20.673C14.7202 21 13.8802 21 12.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V5"
                      stroke="#0695ff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div
                    className="text-mayo-link-text"
                    onClick={() => handleFileDelete()}
                  >
                    画像を削除
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <ul className="flex">
            <li className="flex flex-col items-center mt-10 cursor-pointer">
              <div onClick={() => fileInput.current.click()}>
                <svg
                  className="w-50 h-50 hover:opacity-50"
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="100" height="100" rx="50" fill="#D9D9D9" />
                  <path
                    d="M50 50.375C42.373 50.375 36.25 44.252 36.25 36.625C36.25 29.1055 42.373 22.875 50 22.875C57.5195 22.875 63.75 29.1055 63.75 36.625C63.75 44.252 57.5195 50.375 50 50.375ZM55.3711 55.5312C65.6836 55.5312 74.0625 63.9102 74.0625 74.2227C74.0625 76.2637 72.3438 77.875 70.3027 77.875H29.5898C27.5488 77.875 25.9375 76.2637 25.9375 74.2227C25.9375 63.9102 34.209 55.5312 44.5215 55.5312H55.3711Z"
                    fill="#8E8E8E"
                  />
                </svg>
              </div>
              <div className="flex items-center gap-2 mt-10 hover:opacity-50">
                <svg
                  width="20"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <PlusCircleIcon className="text-mayo-link-text"></PlusCircleIcon>
                </svg>

                <div
                  className="text-mayo-link-text cursor-pointer hover:opacity-50"
                  onClick={() => fileInput.current.click()}
                >
                  画像を追加
                </div>
              </div>
            </li>
          </ul>
        )}
      </div>
      <div className="flex mt-5">
        <input
          type="file"
          onChange={handleFileChange}
          accept=".png,.jpg,.jpeg"
          ref={fileInput}
          style={{ display: "none" }}
        />
      </div>
      <div className="mt-5 divider" />
    </>
  );
};
